(() => {
  const consentmoHostSelector = 'csm-cookie-consent';
  const styleId = 'sunco-consentmo-launcher-size';
  const retryIntervalMilliseconds = 250;
  const maximumAttempts = 120;

  const launcherStyles = `
    #csm-wrapper .csm-csb.csm-csb--shrunk {
      width: 56px !important;
      height: 56px !important;
      min-height: 0 !important;
      padding: 11px 12px !important;
      border-radius: 50% !important;
    }

    #csm-wrapper .csm-csb.csm-csb--shrunk .csm-csb-header-button {
      width: 56px !important;
      height: 56px !important;
      margin: -12px !important;
      padding: 12px !important;
    }
  `;

  function installLauncherStyles() {
    const consentmoHost = document.querySelector(consentmoHostSelector);
    const shadowRoot = consentmoHost?.shadowRoot;

    if (!shadowRoot || shadowRoot.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = launcherStyles;
    shadowRoot.appendChild(style);
  }

  function startInstaller() {
    let attempts = 0;

    installLauncherStyles();

    const intervalId = window.setInterval(() => {
      attempts += 1;
      installLauncherStyles();

      if (attempts >= maximumAttempts) {
        window.clearInterval(intervalId);
      }
    }, retryIntervalMilliseconds);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startInstaller, { once: true });
  } else {
    startInstaller();
  }
})();
